export function mergeArrayToString(separator: string, args: Array<string | null | boolean>): string {
  return args.filter(Boolean).join(separator).trim()
}
